import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useNewItem } from './contexts'
import { useAppointmentType } from 'contexts/AppointmentType'
import { DateTime } from 'luxon'
import { selectAppointmentPriceRules } from 'selectors/AppointmentPriceRulesSelectors'
import { isEmpty } from 'lodash'

export const usePriceRuleForDate = (date) => {
  const { price_rules: priceRuleIds = [] } = useAppointmentType()
  const priceRules = useSelector(selectAppointmentPriceRules(priceRuleIds))

  return useMemo(() => {
    if (date) {
      const weekday = DateTime.fromJSDate(date).weekdayLong.toLowerCase()
      const validRules = priceRules.filter(
        ({ date_from: dateFrom, date_to: dateTo, weekdays = [] }) => {
          return (
            (isEmpty(dateFrom) || dateFrom <= date) &&
            (isEmpty(dateTo) || dateTo > date) &&
            weekdays.includes(weekday)
          )
        }
      )

      if (validRules.length > 0) {
        return validRules[0]
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, priceRules.length])
}

export const useIsEditMode = () => {
  const {
    newItem: { id = '' },
  } = useNewItem()

  return !isEmpty(id)
}
